import { promptLogin } from '@/services/app/mcd';
import { Login as LoginLayout } from '@CS/routes';
import { useDataLayer } from '@CS/hooks';

type LoginProps = {
  onLogin: () => void;
  onError?: (error: Error) => void;
};

export const Login = ({ onLogin, onError }: LoginProps) => {
  const onClick = () =>
    promptLogin()
      .then(() => onLogin())
      .catch((error) => onError?.(error));

  useDataLayer({
    event: 'page_view',
    eventProperties: {
      page_virtual_path: '/GGA25/login',
      page_type: 'Golden_GetAway_2025'
    }
  });

  return <LoginLayout onLogin={onClick} />;
};
